import { render, staticRenderFns } from "./object-fit.vue?vue&type=template&id=22e4a50a&"
import script from "./object-fit.vue?vue&type=script&lang=js&"
export * from "./object-fit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports